import { MedicalExpert } from "@/domain/entity/doctor/medical-expert-entity";
import { DoctorRepository } from "@/domain/repository/doctor-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchDoctorListUsecase {
  constructor(private readonly doctorRepo: DoctorRepository) {}

  async execute(): Promise<SATResult<MedicalExpert[], SATError>> {
    return this.doctorRepo.fetchDoctors();
  }
}
